/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { MultiSelect, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import MeRepository from '../../../helpers/api/MeRepository';

export default class ProjectMultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: [],
      selectedItems: []
    };
    this.onChange = this.onChange.bind(this);
  }

  async componentDidMount() {
    if (!this.props.company) return;
    this.setState({ loading: true });
    const items = await this.getItems();
    this.setState({ items, selectedItems: this.props.initialSelectedItems, loading: false });
  }

  onChange = (selectedItem) => {
    const items = selectedItem ? selectedItem.selectedItems : null;
    this.setState({
      selectedItems: items
    });
    this.props.onChange(items);
  };

  getItems = async () => {
    let items = [];
    try {
      items = await MeRepository.getProjects(this.props.company);
    } catch (error) {
        console.error(error);
      this.props.onError(error);
    }
    return items;
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <MultiSelect.Filterable
        id="ddlProjects"
        disabled={this.state.items < 1 || this.props.disabled}
        placeholder={
          this.state.selectedItems < 1
            ? 'Choose one or more items'
            : this.state.selectedItems.map((elem) => elem.name).join(', ')
        }
        label=""
        itemToString={(item) => (item ? item && item.name : '')}
        items={this.state.items}
        light={false}
        onChange={this.onChange}
        type="default"
        initialSelectedItems={this.props.initialSelectedItems}
      />
    );
  }
}

ProjectMultiSelect.propTypes = {
  company: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  initialSelectedItems: PropTypes.array,
  disabled: PropTypes.bool
};
ProjectMultiSelect.defaultProps = {
  company: null,
  initialSelectedItems: [],
  disabled: true
};
